import React from 'react';

export const AppContext = React.createContext({});
export const withContext = (View) => (props) => <AppContext.Consumer>{context => <View {...props} context={context}/>}</AppContext.Consumer>;